import { Reducer } from 'redux';
import { ActionType } from 'typesafe-actions';
import { TimelineActions } from '../actions';
import {
  ActionTypes,
  PresetType,
  SlidePanelContent,
  SlidePanelPosition,
  SlidePanelSide,
  TimelineState,
  ViewModeType
} from '../types';

type TimelineAction = ActionType<typeof TimelineActions>;

export const InitialTimelineState: TimelineState = {
  parentMediaId: 642726,
  startDate: new Date(),
  endDate: new Date(),
  viewModeType: ViewModeType.Days,
  preset: PresetType.Week,
  selectedMediaId: 0,
  sidePanelPosition: SlidePanelPosition.Closed,
  sidePanelContent: SlidePanelContent.Empty,
  sidePanelSide: SlidePanelSide.Left
};

export const timeline: Reducer<TimelineState> = (
  state: TimelineState = InitialTimelineState,
  action: TimelineAction
) => {
  switch (action.type) {
    case ActionTypes.SET_RANGE_AND_VIEW_MODE: {
      return {
        ...state,
        viewModeType: action.payload.viewModeType,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate
      };
    }
    case ActionTypes.SET_RANGE: {
      return {
        ...state,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate
      };
    }
    case ActionTypes.SET_VIEW_MODE: {
      return {
        ...state,
        viewModeType: action.payload.viewModeType
      };
    }
    case ActionTypes.SET_PRESET: {
      return {
        ...state,
        preset: action.payload.preset
      };
    }
    case ActionTypes.SET_SELECTED_MEDIA_ID: {
      return {
        ...state,
        selectedMediaId: action.payload.mediaId
      };
    }
    case ActionTypes.SET_SLIDE_PANEL_POSITION_AND_CONTENT: {
      return {
        ...state,
        sidePanelPosition: action.payload.slidePanelPosition,
        sidePanelContent: action.payload.slidePanelContent,
        sidePanelSide: action.payload.slidePanelSide
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/timeline.ts